import type { Messages } from './en';

export const MESSAGES_FR: Messages = {
  secure_tagadapay: 'Paiement Sécurisé propulsé par Tagada',
  checkout_title: 'Paiement Sécurisé',
  checkout_subtitle: 'Finalisez votre achat en toute sécurité',
  express_payment: 'Paiement Express',
  express_payment_apple_pay: 'Payer avec Apple Pay',
  express_payment_subtitle: 'Ignorer le formulaire de paiement',
  informations_title: 'Informations',
  informations_subtitle: 'Entrez vos informations personnelles',
  shipping_address_title: 'Adresse de Livraison',
  shipping_address_subtitle: 'Entrez votre adresse de livraison',
  shipping_method_title: 'Méthode de Livraison',
  shipping_method_subtitle: 'Sélectionnez votre méthode de livraison ci-dessous',
  shipping_method_warning_title: 'Information',
  shipping_method_warning_text: 'Aucune méthode de livraison trouvée dans votre pays',
  billing_address_check: "L'adresse de facturation est différente de l'adresse de livraison",
  billing_method_title: 'Méthode de Facturation',
  billing_method_subtitle: 'Entrez votre adresse de facturation',
  payment_title: 'Paiement',
  payment_subtitle:
    'Sélectionnez votre méthode de paiement ci-dessous. Toutes les transactions sont sécurisées et cryptées',
  payment_credit_card: 'Carte de crédit ou de débit',
  payment_credit_card_subtitle: 'Paiement sécurisé par carte bancaire',
  payment_paypal_subtitle: 'Paiement sécurisé et rapide avec PayPal',
  payment_bridge_subtitle: 'Paiement sécurisé et rapide avec Bridge',
  payment_klarna_subtitle: 'Paiement sécurisé et rapide avec Klarna',
  payment_generic_subtitle: 'Paiement sécurisé et rapide',
  default_payment_method_short: 'Par défaut',
  order_summary_discount_code: 'Code de réduction',
  order_summary_discount_discovered_callout: 'Vous avez des codes de réductions disponibles',
  order_summary_discount_discovered_callout_action: 'Les ajouter tous',
  order_summary_title: 'Votre commande',
  order_summary_subtotal: 'Sous-total',
  order_summary_shipping: 'Livraison',
  order_summary_discount: 'Réduction',
  order_summary_tax: 'Taxes estimées',
  order_summary_total: 'Total',
  order_summary_total_savings: 'Réductions',
  button_pay: 'Payer maintenant',
  button_pay_with_gateway: 'Payer avec {gateway}',
  loading: 'Chargement...',
  error_missing_checkout_session_id: 'Identifiant de session de paiement manquant',
  error_checkout_session_not_found: 'Session de paiement introuvable',
  error_order_already_completed: 'Commande déjà complétée',
  error_checkout_session_items_empty: 'Votre panier est vide',
  order_not_found: 'Commande introuvable',
  thank_you_title: 'Merci pour votre commande!',
  thank_you_subtitle: 'Votre commande a été validée avec succès.',
  thank_you_email_sent: 'Nous vous avons envoyé un email de confirmation sur votre adresse email :',
  thank_you_order_details: 'Détails de la commande',
  thank_you_reference: 'Référence',
  thank_you_date: 'Date',
  thank_you_total: 'Total',
  thank_you_button_continue: 'Continuer vos achats',
  term_and_privacy_clicking_text: "En cliquant sur ce bouton, j'accepte les",
  term_and_condition_link_text: 'Conditions Générales',
  privacy_policy_link_text: 'Politique de Confidentialité',
  refund_policy_link_text: 'Politique de Remboursement',
  shipping_policy_link_text: 'Politique de Livraison',
  billed_as_text: 'Votre carte de crédit sera débitée sous le nom {domain}.',
  you_must_accept_policies: 'Vous devez accepter nos',
  and: 'et',
  comma: ',',
  payment_error_title: 'Erreur',
  checkout_preview_title: 'Mode Aperçu - Ceci est une page de paiement de test',
  order_summary_discount_code_apply_button: 'Appliquer',
  optional: 'optionnel',
  field_phone: 'Téléphone',
  field_phone_placeholder: 'Indiquez votre numéro de téléphone',
  field_phone_required_text: 'Numéro de téléphone requis',
  field_company: 'Société',
  field_company_placeholder: 'Indiquez le nom de votre entreprise',
  checkbox_billing_address: "L'adresse de facturation est différente de l'adresse de livraison",
  billing_address_title: 'Adresse de Facturation',
  billing_address_subtitle: 'Indiquez votre adresse de facturation',
  field_first_name: 'Prénom',
  field_first_name_placeholder: 'Indiquez votre prénom',
  field_first_name_error_message: 'Ce champ est requis',
  field_last_name: 'Nom',
  field_last_name_placeholder: 'Indiquez votre nom',
  field_last_name_error_message: 'Ce champ est requis',
  field_address: 'Adresse',
  field_address_placeholder: '123 rue principale, Ville, Pays',
  field_address_error_message: 'Ce champ est requis',
  field_additional_address: 'Adresse complémentaire',
  field_additional_address_placeholder: 'Appartement, étage, etc.',
  field_additional_address_error_message: 'Ce champ est requis',
  field_city: 'Ville',
  field_city_placeholder: 'Indiquez votre ville',
  field_city_error_message: 'Ce champ est requis',
  field_country: 'Pays',
  field_country_error_message: 'Ce champ est requis',
  field_state: 'État',
  field_state_placeholder: 'Indiquez votre état',
  field_state_error_message: 'Ce champ est requis',
  field_postal_code: 'Code Postal',
  field_postal_code_placeholder: 'Indiquez votre code postal',
  field_postal_code_error_message: 'Ce champ est requis',
  field_email: 'Email',
  field_email_placeholder: 'Indiquez votre email',
  field_email_error_message: 'Ce champ est requis',
  credit_card_method: 'Carte de crédit',
  card_error_message: 'Informations de carte invalides',
  card_number: 'Numéro de carte',
  card_number_placeholder: 'Indiquez votre numéro de carte',
  card_number_error_message: 'Ce champ est requis',
  expiry_date: "Date d'exp.",
  expiry_date_placeholder: 'MM/AA',
  expiry_date_error_message: 'Ce champ est requis',
  expiry_date_error_message_expired: "La date d'expiration est passée",
  cvc: 'CVC/CVV',
  cvc_placeholder: '123',
  cvc_error_message: 'Le CVC doit être de 3 ou 4 chiffres',
  payment_methods_loading_error: 'Échec du chargement des méthodes de paiement',
  recommanded: 'Recommandé',
  free: 'Gratuit',
  customer_update_error: 'Erreur lors de la mise à jour des informations',
  shipping_method_empty_country: 'Sélectionnez un pays pour voir les méthodes de livraison disponibles',
  shipping_method_update_error: 'Erreur lors de la mise à jour des informations de livraison',
  items: '{count} items',
  back: 'Retour',
  continue_to_shipping: 'Continuer vers la livraison',
  continue_to_payment: 'Continuer vers le paiement',
  contact_title: 'Contact',
  contact_title_subtitle: 'Entrez vos informations de contact',
  pay_now: 'Payer',
  secure_payment_message: 'Toutes les transactions sont sécurisées et cryptées',
  interval_day: 'jour',
  interval_week: 'semaine',
  interval_month: 'mois',
  interval_year: 'année',
  interval_day_plural: 'jours',
  interval_week_plural: 'semaines',
  interval_month_plural: 'mois',
  interval_year_plural: 'années',
  every_interval: 'Tous les {count} {interval}',
  billing_every_interval: 'Facturation tous les {count} {interval}',
  delivery_every_interval: 'Livraison tous les {count} {interval}',
  free_trial_period: "{duration} {type} d'essai gratuit",
  first_payment_free: 'Premier paiement gratuit',
  subscription_trial_notice:
    "Votre abonnement inclut une période d'essai gratuite. Vous ne serez pas facturé avant la fin de la période d'essai.",
  recurring_total_with_interval: 'Total récurrent (tous les {count} {interval})',
  trial_ends_on: "L'essai se termine le {date}",
  billing_timing: 'Facturation : {timing}',
  billing_cycle_anchor: 'Ancre du cycle de facturation',
  field_marketing_label: "J'accepte de recevoir des emails marketing",
  terms_acceptance_text: "J'accepte les termes et conditions",
  cart_title: 'Panier',
  payment_failed_message: 'Le paiement a échoué',
  email: {
    abandoned_checkout: {
      preview: 'Finalisez votre achat',
      default_body:
        'Nous avons remarqué que vous avez laissé des articles dans votre panier. Souhaitez-vous finaliser votre achat ?',
      cart_title: 'Votre Panier',
      quantity: 'Quantité',
      recurring: 'Récurrent tous les {interval}',
      trial_period: "({duration} {type} d'essai)",
      subtotal: 'Sous-total',
      discounts: 'Réductions',
      total: 'Total',
      cta_button: 'Finaliser votre achat',
      footer_text:
        'Si vous avez des questions, répondez simplement à cet email - nous sommes toujours là pour vous aider.',
    },
    order_paid: {
      // Add order paid email translations here when needed
    },
  },
  image_upload: {
    errors: {
      unauthorized: "Vous n'êtes pas autorisé",
      unsupported_content_type: 'Type de fichier non supporté',
      single_file_required: 'Un seul fichier est requis',
      file_too_big: 'Le fichier est trop volumineux',
      non_image_file: 'Impossible de traiter autre chose que des images',
    },
  },
  promotion_code_invalid: "Ce code promo n'est pas valide",
  applying: 'Application...',
  processing_payment: 'Traitement du paiement...',
  select_country: 'Sélectionnez un pays',
  select_state: 'Sélectionnez un état',
  order_details: 'Détails de la commande',
  order_number: 'Numéro de commande',
  order_date: 'Date de commande',
  email_confirmation: 'Confirmation par email',
  confirmation_sent_to: 'Email de confirmation envoyé à',
  shipping_address: 'Adresse de livraison',
  billing_address: 'Adresse de facturation',
  payment_successful: 'Paiement réussi',
  recurring_total: 'Total récurrent',
  payment_is_blacklisted: 'Le paiement est bloqué',
  checkout_has_errors_title: 'Validation',
  checkout_has_errors: 'Les informations ci-dessous sont invalides ou manquantes',
  checkout_email_error: 'adresse email',
  checkout_shipping_address_error: 'adresse de livraison',
  checkout_billing_address_error: 'adresse de facturation',
  checkout_shipping_rate_error: 'mode de livraison',
  checkout_pickup_address_error: 'point relais',
  checkout_payment_info_error: 'informations de paiement',
  checkout_phone_error: 'numéro de téléphone',
  checkout_terms_error: "vous n'avez pas accepté les termes et conditions",
  payment: {
    genericError: 'Payment failed. Please try again with a different payment method.',
  },
  error: {
    unexpected: 'An unexpected error occurred. Please try again.',
  },
  checkout_completed_title: 'Paiement Terminé',
  checkout_already_completed: 'Cette commande a déjà été payée',
  payment_completed: 'Paiement Effectué',
  apply_vip_offers: 'Payer en tant que VIP',
  confirm_vip_payment: 'Payer',
  cancel_vip_offers: 'Annuler les offres VIP',
  vip_total_difference: 'Différence : {difference}',
  total_as_vip: 'VIP',
  vip_savings: 'Économies VIP',
  vip_savings_available: 'Économies VIP Disponibles',
  vip_savings_confirmed: 'Économies VIP Appliquées',
  vip_savings_message: 'Sélectionnez le paiement VIP pour débloquer ces économies !',
  vip_savings_applied_message: 'Vous économisez {amount} avec les avantages VIP !',
  vip_offer_savings_confirmed: 'Offre VIP appliquée',
  vip_offer_savings_available: 'Offre VIP disponible',
  vip_offer_savings_message: "Appliquez l'offre VIP pour économiser sur votre commande",
  vip_offer_savings_applied_message: "Vous économisez {amount} avec l'offre VIP",
  apply_vip_offer: 'Payer en tant que VIP',
  cancel_vip_offer: "Annuler l'offre VIP",
  you_save: 'Vous économisez {amount}',
  you_save_on_order: 'Vous économisez {amount} sur votre commande',
  you_save_available: "Économisez {amount} sur votre commande avec l'offre VIP exclusive",
  free_trial_then_price: 'Essai gratuit de {duration} {type}, puis {price}/{interval}',
  free_trial_period_short: '{duration} {type} gratuit',
  click_to_apply: 'Cliquer pour appliquer',
  please_select_shipping_country:
    'Veuillez sélectionner un pays pour voir les méthodes de livraison disponibles',
  invalid_phone_number: 'Numéro de téléphone non valide',
  click_errors_to_navigate: "Cliquer pour naviguer à l'erreur",
  pickup_point: 'Point relais',
  monday: 'Lundi',
  tuesday: 'Mardi',
  wednesday: 'Mercredi',
  thursday: 'Jeudi',
  friday: 'Vendredi',
  saturday: 'Samedi',
  sunday: 'Dimanche',
  promotion_code_usage_limit_reached: "Ce code promotionnel a atteint sa limite d'utilisation",
  promotion_code_first_time_only: "Ce code promotionnel n'est valable que pour les nouveaux clients",
  promotion_code_invalid_email: "Ce code promotionnel n'est pas valide pour votre adresse email",
  promotion_code_cannot_apply: 'Ce code promotionnel ne peut pas être appliqué',
  promotion_code_already_applied: 'Cette promotion est déjà appliquée',
  promotion_code_expired: 'Ce code promotionnel a expiré',
  promotion_code_cannot_remove_auto: 'Impossible de supprimer les promotions appliquées automatiquement',
  promotion_code_remove_failed: 'Échec de la suppression du code promotionnel',
  remove: 'Supprimer',
  pickup_select_point: 'Sélectionner un point relais',
  pickup_select_point_description: 'Choisissez un point relais près de chez vous',
  pickup_click_to_select: 'Cliquer pour sélectionner',
  pickup_change_point: 'Changer de point relais',
  pickup_change: 'Changer',
  pickup_opening_hours: "Heures d'ouverture",
  pickup_closed: 'Fermé',
  pickup_point_error: 'Une erreur est survenue lors de la sélection du point relais',
  pickup_view_list: 'Vue liste',
  pickup_view_map: 'Vue carte',
  pickup_open_map: 'Ouvrir la carte',
  pickup_open_map_description: 'Cliquez pour ouvrir la carte interactive',
  pickup_no_points_found: 'Aucun point relais trouvé dans cette zone',
  cancel: 'Annuler',
  order_confirmed: 'Commande Confirmée',
  view_order_details: 'Voir les détails de la commande',
  back_to_portal: 'Retour au portail',
  customer_details: 'Détails du client',
  customer_email: 'Email',
  customer_id_label: 'ID Client',
  customer_first_name: 'Prénom',
  customer_last_name: 'Nom de famille',
  customer_locale: 'Langue',
  marketing_consent: 'Préférences marketing',
  marketing_accepted: 'Inscrit au marketing',
  marketing_declined: 'Non inscrit au marketing',
  customer_created_at: 'Client depuis',
  order_status_label: 'Statut de la commande',
  order_status_paid: 'Payée',
  order_status_pending: 'En attente',
  order_status_cancelled: 'Annulée',
  post_purchase: {
    title: 'Nous avons trouvé ces offres spécialement pour vous',
    view_deal: "Voir l'offre",
    get_deal_now: "Obtenir l'offre",
    bundle_content: '{count, plural, =0 {aucun article} =1 {# article} other {# articles}}',
    adding_to_cart: 'Traitement en cours...',
    vip_only: 'VIP uniquement',
    products: '{count, plural, =0 {Aucun produit} =1 {# produit} other {# produits}}',
    skip: 'passer',
    skip_addition: 'aller à votre récapitulatif',
    exclusive_offer: 'Offre exclusive unique',
    offer_expires_in: "L'offre expire dans",
    minutes: 'min',
    save: 'Économisez',
    secure_checkout: 'Paiement 100% sécurisé',
    safe_payment: 'Protection acheteur garantie',
    limited_time_offer: 'Offre à durée limitée',
    previous: 'Précédent',
    no_thanks: 'Non merci',
    offer_count: 'Offre {current} sur {total}',
    special_offer_title: 'Offre spéciale pour vous',
  },
  billing_plan: 'Plan de facturation',
  customer: 'Client',
  current_period: 'Période en cours',
  trial_period: "Période d'essai",
  cancellation_notice: 'Avis de résiliation',
  subscription_cancellation_end_period: 'Cet abonnement sera annulé à la fin de la période en cours.',
  created: 'Créé',
  product_id: 'ID du produit',
  resuming: 'Reprise...',
  resume_subscription: "Reprendre l'abonnement",
  canceling: 'Annulation...',
  cancel_subscription: "Annuler l'abonnement",
  my_subscriptions: 'Mes abonnements',
  subscriptions: 'abonnements',
  no_active_subscriptions: "Vous n'avez aucun abonnement actif.",
  active: 'Actif',
  trial: "Période d'essai",
  loading_subscriptions: 'Chargement de vos abonnements...',
  qty: 'Qté',
  id: 'ID',
  by_canceling: 'En annulant, vous allez :',
  lose_club_advantages: "Perdre tous les avantages d'être membre du club",
  lose_accumulated_credits: "Perdre tous les crédits que vous avez accumulés jusqu'à présent",
  lose_promotion_code:
    'Perdre votre code promotionnel personnel avec des promotions exclusives sur toute la boutique',
  confirm_proceed: 'Êtes-vous sûr de vouloir continuer ?',
  cancel_club_membership: 'Ceci annulera votre adhésion au club à la fin du cycle de facturation en cours.',
  cancel_subscription_notice: 'Ceci annulera votre abonnement à la fin du cycle de facturation en cours.',
  keep_subscription: "Garder l'abonnement",
  yes_lose_benefits: "Oui, je veux perdre tous les avantages d'être membre du Subclub",
  yes_cancel: 'Oui, annuler',
  cancel_subscription_title: "Annuler l'abonnement",
  membership: 'Adhésion',
  related_orders: 'Commandes associées',
  related_orders_description: 'Commandes effectuées via des offres post-achat',
  order_status: 'Statut',
  order_total: 'Total',
  order_items: 'Articles',
  order_type: 'Type',
  view_order: 'Voir la commande',
  order_item_count: '{count, plural, =1 {# article} other {# articles}}',
  related_order_from: "De l'offre {offerType}",
  no_related_orders: 'Aucune commande associée',
  total_with_related_orders: 'Total avec commandes associées',
  discount_applied: 'Réduction appliquée',
  paid: 'Payé',
  pending: 'En attente',
  processing: 'En cours',
  cancelled: 'Annulé',
  refunded: 'Remboursé',
  vip_post_purchase: {
    title: 'Vous avez encore le temps !',
    subtitle: 'Abonnez-vous à notre club et gagnez gros !',
    action_cancel: 'Non, merci',
    action_subscribe: "S'abonner",
    savings: 'Vous économisez {amount}',
    offer_title: 'Offre Exclusive à Ne Pas Manquer',
    offer_description: '',
  },
  shopify: {
    notes: {
      sendcloud_pickup: {
        id: 'ID Point Retrait',
        name: 'Nom Point Retrait',
        street: 'Adresse Point Retrait',
        type: 'Type Point Retrait',
        city: 'Ville Point Retrait',
        postal_code: 'Code postal Point Retrait',
        country: 'Pays Point Retrait',
        carrier: 'Transporteur Point Retrait',
        code: 'Code Point Retrait',
        latitude: 'Latitude Point Retrait',
        longitude: 'Longitude Point Retrait',
      },
    },
  },
};
